import alphabet from './alphabet';

export default {
    alphabet
};
